var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVectorimg6(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 350,
    height: 77,
    viewBox: "0 0 350 77",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M339.973 28.3324C335.799 28.3324 332.216 31.0172 330.737 34.7895C272.295 38.6638 123.923 38.358 72.6801 34.2798C70.5765 15.554 55.2266 0.974365 36.524 0.974365C16.3751 0.974365 0.0390625 17.8649 0.0390625 38.6978C0.0390625 59.5307 16.3751 76.4214 36.524 76.4214C55.128 76.4214 70.4122 61.9777 72.6473 43.3539C130.53 39.2077 264.012 38.6979 330.737 42.6741C332.249 46.4125 335.799 49.0633 339.973 49.0633C345.495 49.0633 349.998 44.4413 349.998 38.6978C349.998 32.9543 345.528 28.3324 339.973 28.3324Z",
    fill: "#B3858A"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVectorimg6);
export default __webpack_public_path__ + "static/media/Vectorimg6.623f40b71ba3e1df272c7ed82dd7b188.svg";
export { ForwardRef as ReactComponent };